module.exports = __webpack_public_path__ + "img/icon-track.66421ada.png";